





import { defineComponent } from "@vue/composition-api";
import router from "@/router";
import queryString from "query-string";
import Loading from "@/components/Loading.vue";
import { getOIDCCode, OIDCAuthRequest } from "@/data/repos/oidc";

function redirectTo(url: string, params: object) {
  window.location.href = url + "?" + queryString.stringify(params);
}

export default defineComponent({
  components: { Loading },
  async setup() {
    const query = router.currentRoute.query;
    if (query.oidc) {
      const oidcQuery = queryString.parse(
        query.oidc as string
      ) as unknown as OIDCAuthRequest;
      if (!oidcQuery.client_id) {
        oidcQuery.client_id = "pR2ZrN6w9I9s3KtncFiNV5bwQ8RTtQo5y-J4AYfIbwE"; // todo remove after SINGU passes
      }
      if (!oidcQuery.scope) {
        oidcQuery.scope = "openid profile email"; // todo remove after SINGU passes
      }
      if (oidcQuery.client_id) {
        const oidcResp = await getOIDCCode(oidcQuery);
        if (oidcResp.ok && oidcResp.payload?.code) {
          redirectTo(oidcQuery.redirect_uri as string, {
            code: oidcResp.payload.code,
            state: oidcQuery.state,
          });
          return;
        } else {
          await router.push({
            name: "Error",
            query: {
              errorMessage:
                "OIDC authentication failed. " + oidcResp.payload?.errorMessage,
            },
          });
        }
      } else {
        // TODO: legacy code, should replaced with the error message below
        // await router.push({
        //   name: "Error",
        //   query: { errorMessage: "Invalid OIDC query. Missing client_id." },
        // });
        const response = {
          state: oidcQuery.state,
          nonce: oidcQuery.nonce,
          code: query.session_id,
        };
        redirectTo(oidcQuery.redirect_uri as string, response);
      }
    } else {
      await router.push({
        name: "pre-login",
        query: { oidc: queryString.stringify(router.currentRoute.query) },
      });
    }
  },
});
